import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
export const CartConfirmation = ({
  selectedProducts,
  productData,
  cartItems,
  onBack,
  onContinue
}) => {
  // Use cartItems if available, otherwise fallback to the old method
  const displayItems = cartItems && cartItems.length > 0 ? cartItems : Object.entries(selectedProducts).filter(([_, isSelected]) => isSelected).map(([productType]) => {
    // Find the first product of each selected type
    const product = productData[productType]?.[0];
    return product ? {
      type: productType,
      ...product
    } : null;
  }).filter(Boolean);
  return <div className="flex flex-col p-6 flex-grow" data-id="element-141">
      <div className="flex items-center mb-6" data-id="element-142">
        <button onClick={onBack} className="mr-4" data-id="element-143">
          <ChevronLeftIcon size={24} data-id="element-144" />
        </button>
      </div>
      <h1 className="text-2xl font-bold mb-2" data-id="element-145">Review your selection</h1>
      <p className="text-gray-700 mb-6" data-id="element-146">
        Please confirm the products you'd like to open
      </p>
      {displayItems.map((item, index) => <div key={index} className="border rounded-lg p-4 mb-4" data-id="element-147">
          <div className="flex justify-between items-start" data-id="element-148">
            <div data-id="element-149">
              <h3 className="font-bold" data-id="element-150">{item.name}</h3>
              <p className="text-gray-700" data-id="element-151">{item.description}</p>
              {item.type === 'savings' && <p className="text-gray-700 mt-1" data-id="element-152">
                  Open your savings account and you become part owner of
                  Pinnacle - with all the benefits of membership.
                </p>}
            </div>
          </div>
        </div>)}
      <div className="mt-auto" data-id="element-153">
        <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium mb-4" onClick={onContinue} data-id="element-154">
          Continue to Application
        </button>
        <button className="w-full text-[#5c5cf5] font-medium" onClick={onBack} data-id="element-155">
          Edit Selection
        </button>
      </div>
    </div>;
};